<template>
    <section class="border-border-light dark:border-border-dark space-y-4 border-y pt-6 pb-6">
        <h3 class="text-text-light dark:text-text-dark text-sm font-semibold">
            {{ heading ?? trans('maintainers.sla.affected_assets.title') }}
            <span class="text-subtext-light dark:text-subtext-dark font-normal">({{ assets.length }})</span>
        </h3>

        <div v-if="assets.length === 0" class="text-subtext-light dark:text-subtext-dark text-sm">
            {{ trans('maintainers.sla.affected_assets.empty') }}
        </div>

        <ul v-else class="max-h-60 list-none space-y-1 overflow-y-auto !pl-0">
            <li v-for="asset in sortedAssets" :key="asset.id" class="rounded px-2 py-2">
                <div class="text-text-light dark:text-text-dark truncate text-sm font-medium">
                    {{ modelDesignation(asset) }}
                </div>
                <div class="text-subtext-light dark:text-subtext-dark flex flex-wrap gap-x-3 text-xs">
                    <span v-if="asset.location">{{ asset.location.airport }} — {{ asset.location.name }}</span>
                    <span v-if="asset.curieId">{{ asset.curieId }}</span>
                    <span v-if="asset.serialNumber">{{ trans('general.label.serial_number') }} {{ asset.serialNumber }}</span>
                </div>
            </li>
        </ul>
    </section>
</template>

<script setup>
import { trans } from '@/mixins/i18n';
import { computed } from 'vue';

const props = defineProps({
    assets: {
        type: Array,
        default: () => [],
    },
    heading: {
        type: String,
        default: null,
    },
});

// AssetBaseInfoResource nests the model as a ModelResource, which Inertia
// serializes with a `data` wrapper (model.data.designation); other callers may
// pass it flat (model.designation). Read both shapes.
const modelDesignation = (asset) => asset.model?.data?.designation ?? asset.model?.designation ?? '';

const sortedAssets = computed(() =>
    [...props.assets].sort((a, b) => {
        const locA = a.location?.airport ?? '';
        const locB = b.location?.airport ?? '';
        return locA.localeCompare(locB) || (a.location?.name ?? '').localeCompare(b.location?.name ?? '');
    }),
);
</script>
